var map = {
	"./alan-garcia.png": "b641",
	"./alberto-andrade.png": "31e0",
	"./alberto-beingolea.png": "1949",
	"./alberto-de-belaunde.png": "a386",
	"./alejandro-toledo.png": "8352",
	"./andres-alcantara.png": "cc15",
	"./anel-townsend.png": "48ef",
	"./aun-no-decide-por-quien-votara.png": "7239",
	"./bernardo-jaime-quito-sarmiento.png": "0073",
	"./blanco-viciado.png": "7852",
	"./carlos-bruce.png": "ef56",
	"./cecilia-chacon.png": "86f0",
	"./cesar-acuna.png": "2906",
	"./ciro-galvez.png": "c046",
	"./daniel-abugattas.png": "f06d",
	"./daniel-salaverry.png": "1e3b",
	"./daniel-urresti.png": "c16e",
	"./enrique-fernandez-chacon.png": "ce24",
	"./gabriela-perez-del-solar.png": "d61c",
	"./george-edward-malaga-trillo.png": "621d",
	"./george-forsyth.png": "87d6",
	"./hernando-de-soto.png": "e78f",
	"./humberto-lay-sun.png": "ac93",
	"./jaime-delgado.png": "d605",
	"./jorge-carlos-montoya-manrique.png": "dfd8",
	"./jose-leon-luna-galvez.png": "7f23",
	"./jose-vega copy.png": "1677",
	"./jose-vega.png": "00a1",
	"./julio-guzman.png": "77e0",
	"./keiko-fujimori.png": "e130",
	"./kenji-fujimori.png": "2d48",
	"./marco-arana-Recovered.png": "9b4e",
	"./marco-arana.png": "8e36",
	"./maria-de-los-milagros-jackeline-jauregui-martinez-de-aguayo.png": "8e74",
	"./martha-chavez.png": "3869",
	"./martin-alberto-vizcarra-cornejo.png": "07ba",
	"./maurice-mulder.png": "7ee0",
	"./mercedes-araoz.png": "a36f",
	"./mercedes-cabanillas.png": "9ce3",
	"./ninguno-blanco-viciado.png": "f278",
	"./ninguno-de-ellos.png": "5c0e",
	"./ninguno-nadie.png": "58a5",
	"./no-precisa.png": "d212",
	"./no-sabe.png": "fd31",
	"./ns-np.png": "2edb",
	"./ollanta-humala.png": "cb29",
	"./otros.png": "1bc9",
	"./pedro-castillo.png": "87f8",
	"./pedro-pablo-kucynski.png": "0d82",
	"./rafael-lopez-aliaga.png": "bcfd",
	"./rafael-santos.png": "7548",
	"./richard-acuna.png": "b04e",
	"./susel-ana-maria-paredes-pique.png": "a529",
	"./veronika-mendoza.png": "e594",
	"./yeni-vilcatoma.png": "fb07",
	"./yeremi-espinoza.png": "c81b",
	"./yonhi-lescano.png": "ec0e",
	"./yonhy-lescano.png": "5d61"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1ad2";